import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getCoursesById, searchCourses, searchCoursesByCourseOrClubName } from './thunks'
import { reactivateCourse, deactivateCourse, duplicateCourse } from 'store/course/thunks'

const initialState: Courses = {
  courses: [],
  status: 'idle',
  error: null,
  searchFilters: {},
  totalCount: 0,
}

const slice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    clearCourses: (state) => {
      state.courses = []
    },
    saveSearchFilters: (state, action) => {
      state.searchFilters = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCourses.pending, (state, action) => {
        state.status = 'loading'
        state.error = null
        const { offset } = action.meta.arg.data
        const isFirstFetch = [0, undefined].includes(offset)
        if (isFirstFetch) {
          state.courses = []
        }
      })
      .addCase(searchCourses.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(searchCourses.fulfilled, (state, action) => {
        state.status = 'succeeded'
        const { offset } = action.meta.arg.data
        const isFirstFetch = [0, undefined].includes(offset)
        state.courses = isFirstFetch ? action.payload : state.courses.concat(action.payload)
      })

    builder
      .addCase(searchCoursesByCourseOrClubName.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(searchCoursesByCourseOrClubName.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(searchCoursesByCourseOrClubName.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.courses = action.payload.courses
        state.totalCount = action.payload.totalCount
      })

    builder.addCase(reactivateCourse.fulfilled, (state, action) => {
      const updatedId = action.payload.id
      const currentIndex = state.courses.map((course: Course) => course.id).indexOf(updatedId)
      if (currentIndex >= 0) {
        state.courses[currentIndex] = action.payload
      }
    })

    builder.addCase(deactivateCourse.fulfilled, (state, action) => {
      const updatedId = action.payload.id
      const currentIndex = state.courses.map((course: Course) => course.id).indexOf(updatedId)
      if (currentIndex >= 0) {
        state.courses[currentIndex] = action.payload
      }
    })

    builder.addCase(duplicateCourse.fulfilled, (state, action) => {
      if (state.courses.length > 0) {
        state.courses.unshift(action.payload)
      }
    })
    builder
      .addCase(getCoursesById.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getCoursesById.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getCoursesById.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.courses = action.payload.courses
      })
  },
})

export const { clearCourses, saveSearchFilters } = slice.actions

export const selectCourses = (state: RootState): Courses => state.courses

export default slice.reducer
